import React, { Component } from 'react'

export default class Registration extends Component {
  render() {
    return (
      <section id="proses-pendaftaran-sertifikat-elektronik">
        <p style={{fontSize: '18px', color: '#0085C7',fontWeight: '600', marginBottom: '25px'}}>Proses Pendaftaran Sertifikat Elektronik</p>
        <p style={{fontSize: '13px', marginBottom: '30px'}}>Untuk mendapatkan sertifikat Elektronik, Sahabat TTE sebagai calon pemilik sertifikat akan melalui 3 (tiga) tahapan nih; Pertama adalah tahap Pengajuan, yang kedua tahap verifikasi, dan yang ketiga adalah tahap penerbitan. Yuk simak info lengkapnya di bawah ini.</p>
        <table class="table-borderless w-100 table-proses-daftar">
          <tr>
            <td style={{width: '20px'}}>1</td>
            <td>Tahap Pengajuan</td>
          </tr>
        </table>
        <p style={{fontSize: '13px', marginBottom: '30px'}}>Tahap pengajuan dilakukan langsung pada PSrE atau Registration Authority (RA). Khusus ASN/TNI/POLRI wajib mendaftar pada PSrE Instansi Penyelenggara Negara.</p>
        <table class="table-borderless w-100 table-proses-daftar">
          <tr>
            <td style={{width: '20px'}}>2</td>
            <td>Tahap Verifikasi</td>
          </tr>
        </table>
        <p style={{fontSize: '13px', marginBottom: '30px'}}>Tahap Verifikasi dilakukan langsung pada PSrE atau Registration Authority (RA). Level 3 : Diversifikasi dengan Basis Data Kementerian yang Berwenang. Level 4 : Diversifikasi dengan Basis Data Kementerian yang Berwenang ditambah 2 faktor autentifikasi (kartu identitas + data biometrik).</p>
        <table class="table-borderless w-100 table-proses-daftar">
          <tr>
            <td style={{width: '20px'}}>3</td>
            <td>Tahap Penertiban</td>
          </tr>
        </table>
        <p style={{fontSize: '13px', marginBottom: '30px'}}>Setelah lolos verifikasi, Sertifikat Elektronik diberikan dan pemiliknya diedukasi.</p>
      </section>
    )
  }
}
